<template>
  <modal
      name="add-edit-exercise-modal"
      :width="`100%`"
      :pivotX="0.5"
      :pivotY="0.5"
      :clickToClose="false"
      :draggable="false"
      @before-open="beforeOpen"
  >
    <vue-scroll>
        <div class="modal_double modal_0">
          <vue-scroll>
            <LoadingOverlay
                :activeSyncProps="activeSync"
                :isFullPageProps="false"
            />
            <InputBox
                ref="InputBox"
                :selectedRowsProps="selectedRow"
                :searchKeywordProps="searchKeyword"
                :pageInfoProps="pageInfo"
                :typeProps="type"
                @resetPresetList="resetPresetList"
                @resetSearchKeyword="resetSearchKeyword"
                @resetInputBox="resetInputBox"
                @validationCheck="validationCheck"
            />
          </vue-scroll>
        </div>

        <div class="md_overlay md_overlay_0"></div>
    </vue-scroll>
  </modal>
</template>
<script>
import InputBox from './inputBox/index'
import _API from "@/api";
import {mapActions} from "vuex"
import LoadingOverlay from "@/components/loadingOverlay/index";

export default {
  name: 'AddExerciseModal',
  components: {LoadingOverlay, InputBox},
  props: [
    'disabled',
  ],
  data() {
    return {
      type: '',
      seqExercise: null,
      seqExerciseGuide: null,
      selectedRow: {},
      pageInfo: {
        size: 12,
        currentPage: 0,
      },
      searchKeyword: {value: ''},
      modalClose: false,
      activeSync: false,
    }
  },
  methods: {
    ...mapActions(['getSelectedPatient']),
    addExercise(data) {
      if (this.disabled)
        return;

      return new Promise((_resolve, reject) => {
        this.activeSync = true;
        this.getSelectedPatient().then(res => {
          data.seqMedicalRelation = res.patientInfo.seqMedicalRelation;
        }).then(() => {
          _API.EXERCISE_LIST.addExercise(data)
              .then(res => {
                this.activeSync = false;
                if (res.data.isSuccess === true && res.status === 200) {
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.add_completed'
                  });
                  this.$emit('appendExerciseList', data, res.data.insertId);
                  this.$refs.InputBox.modalClose();
                } else {
                  this.$modal.show('common-alert-modal', {
                    messageType: '',
                    message: ''
                  }); //define error
                }
              })
        }).catch(e => {
          this.activeSync = false;
          reject(`[addExercise] ${e}`);
        });
      });
    },
    updateExercise(inputData) {
      if (this.disabled)
        return;

      return new Promise((_resolve, reject) => {
        this.activeSync = true;
        inputData.seqExercise = this.seqExercise;
        inputData.exerciseGuide.seqExerciseGuide = this.selectedRow.exerciseGuide.seqExerciseGuide;

        _API.EXERCISE_LIST.updateExerciseBySeqExercise(inputData)
            .then(res => {
              this.activeSync = false;
              if (res.data.isSuccess === true && res.status === 200) {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.save_completed'
                });
                this.$emit('updateExerciseList', inputData);
                this.$refs.InputBox.modalClose();
              } else {
                this.$modal.show('common-alert-modal', {
                  messageType: '',
                  message: ''
                });
              }
            })
            .catch(e => {
              this.activeSync = false;
              reject(`[updateExerciseBySeqExerciseGuide] ${e}`)
            })
      });
    },
    resetPresetList() {
      this.presetList = [];
    },
    resetInputBox() {
      this.selectedRow = {};
    },
    resetSearchKeyword() {
      this.searchKeyword.value = '';
    },
    async validationCheck(type) {
      try {
        const inputData = await this.$refs.InputBox.getValue();
        
        if (type === 'add') {
          this.$modal.show('yes-or-no-modal', {
            questionType: 'add',
            function: this.addExercise,
            funcParam: inputData
          });
        } else if (type === 'save') {
          this.$modal.show('yes-or-no-modal', {
            questionType: 'save',
            function: this.updateExercise,
            funcParam: inputData
          });
        }
      } catch ({messageType, message}) {
        this.$modal.show('common-alert-modal', {messageType, message});
      }
    },
    beforeOpen(event) {
      if (event.params.type === 'edit') {
        this.type = 'edit';
        this.seqExercise = event.params.data.seqExercise;
        this.selectedRow = JSON.parse(JSON.stringify(event.params.data));
      } else if (event.params.type === 'add') {
        this.type = 'add';
      }
    },
  },
  computed: {
    filterItemRows: function () { // 미사용, preset 이 부활하길
      const filteredItemRows = [];

      for (let value of this.presetList) {
        if (this.searchKeyword.value) {
          const isKeywordInPresetTitle = value.exercisePresetTitle.indexOf(this.searchKeyword.value);
          if (isKeywordInPresetTitle > -1) {
            filteredItemRows.push(value);
          }
        } else {
          filteredItemRows.push(value);
        }
      }

      return filteredItemRows;
    }
  },
}
</script>
<style lang="scss">
.v--modal-overlay[data-modal="add-edit-exercise-modal"] {
  .vld-background {
    border-radius: 10px;
  }

  .v--modal {
    background: none;

    .modal_double {
      display: flex;
      width: 720px;

      @media screen and (max-width: 720px) {
        width: 100%;
      }
    }
  }

  .addAndEditExerciseInputBox {
    .bottom_btn_2 a:nth-child(2) {
      width: 190px;
      margin-left: 10px;
    }
  }
}
</style>